<template>
    <div>
        <h3 class="h6 block-title border-bottom ps-0 mb-3">
            <i class="text-primary fa fa-fw fa-gift text-muted me-1"></i>
            Bons cadeau
        </h3>
        <div
            class="block-content block-content-full bg-body-light d-flex justify-content-between align-content-center rounded mb-3"
        >
            <input type="hidden" name="voucherArray" :value="JSON.stringify(vouchersUsed)" />
            <div class="d-flex flex-column w-100">
                <label class="form-label" for="voucher_code">Bon cadeau :</label>
                <input type="text" name="voucher_code" id="voucher_code" ref="voucherCode" class="form-control mb-3" />
                <div v-if="invalidVoucher && error != null" class="text-danger mb-3">{{ error }}</div>
                <div v-for="(item, i) in vouchersUsed" :key="i">
                    <div style="display: flex; flex-firection: row; justify-content: space-between">
                        <p class="text-success mb-3">
                            - Bon cadeau n°{{ item.code }}: {{ item.available_amount }}€ valable jusqu'au
                            {{ parseDate(item.date_end) }}
                        </p>
                        <button type="button" @click="deleteBC(item)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <p v-if="voucherTotal > 0">Montant total de bon(s) cadeau {{ voucherTotal }}€ disponible</p>
                <div v-if="voucherBlocked" class="text-warning mb-3">Ce bon cadeau a été bloqué.</div>
                <div v-if="voucherAmountNull" class="text-warning mb-3">Ce bon cadeau a déjà été utilisé.</div>
                <button
                    type="button"
                    class="btn btn-primary align-items-center text-light rounded-pill px-2"
                    v-on:click="handleVoucherCodeSearch()"
                >
                    Appliquer
                    <i class="fa fa-arrow-right opacity-50 ms-2"></i>
                </button>
            </div>
        </div>
        <div v-if="voucherArray.length > 0" class="block shadow-sm rounded">
            <div class="block-header">
                <h6 class="block-title">Montant à utiliser</h6>
            </div>
            <div class="block-content">
                <ul v-for="(item, i) in vouchersUsed" :key="i" class="p-0">
                    <li class="row">
                        <span class="col-12 col-md-4 d-flex align-items-center">
                            - Bon cadeau n°<b>{{ item.code }}</b>
                            :
                        </span>
                        <div class="col-12 col-md-8">
                            <div class="d-flex align-items-center">
                                <div class="input-group">
                                    <input
                                        type="number"
                                        class="form-control"
                                        min="0"
                                        :max="c_remainPrice < item.available_amount ? c_remainPrice : item.available_amount"
                                        v-model="item.amount"
                                    />
                                    <span class="input-group-text bg-primary text-light">€</span>
                                </div>
                                <span class="w-100 ms-2">/ {{ item.available_amount }}€</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from '../../Calendar/_core/ApiManager'
import { get, sync } from 'vuex-pathify'

export default {
    data: () => ({
        // voucher
        voucher: null,
        voucherArray: [],
        voucherTotal: 0,
        voucherEntered: false,
        voucherApplied: false,
        voucherBlocked: false,
        invalidVoucher: false,
        voucherAmountNull: false,
        error: null,
        vouchersUsed: [],
    }),
    mounted() {
        this.getselectedVoucherItems()
    },
    computed: {
        ...sync('overlay@data', {
            c_payments: 'payments',
            c_voucherUsed: 'voucherUsed'
        }),
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
        }),
    },
    watch: {
        voucherArray(newVal) {
            newVal.forEach(el => {
                if (!this.vouchersUsed.find(v => v.code == el.code)) {
                    this.vouchersUsed.push({ id: el.id, code: el.code, amount: Math.min(this.c_remainPrice, el.available_amount), available_amount: el.available_amount, date_end:el.date_end })
                }
            })
        },
        vouchersUsed: {
            handler(newVal) {
                if(newVal.find(el => el.amount == "")) {
                    newVal[newVal.findIndex(el => el.amount == "")].amount = 1
                }
                this.c_voucherUsed = this.vouchersUsed;
                this.$emit('vouchers-update', newVal.map(x => parseFloat(x.amount, 2)))
            },
            deep: true,
        },
    },
    methods: {
        async getselectedVoucherItems() {
            await ApiManager.getselectedVoucherItems(0).then(res => {
                if (res.data != 0) {
                    res.data.forEach(element => {
                        this.handleVoucherCodeSearch()
                    })
                }
            })
        },
        handleVoucherCodeSearch() {
            // this.$refs.voucherCode.value = 7755872296
            console.log('rzea')

            if (this.$refs.voucherCode.value !== '') {

                axios
                    .get(`/back-office/voucher/check-code`, {
                        params: { code: this.$refs.voucherCode.value },
                    })
                    .then(res => {
                        // Si le code est invalide
                        if (!res.data || Object.keys(res.data).length === 0) {
                            this.voucherApplied = false
                            this.voucher = null
                            this.voucherAmountNull = false
                            this.invalidVoucher = true
                        } else {
                            if (typeof res.data === 'string') {
                                this.invalidVoucher = true
                                this.voucherApplied = false
                                this.voucher = null
                                this.voucherAmountNull = false
                                this.error = res.data
                            } else {
                                if (
                                    !this.voucherArray
                                        .map(e => {
                                            if (e.id == res.data.id) return false
                                        })
                                        .includes(false)
                                ) {
                                    this.voucherArray.push(res.data)
                                    this.voucherTotal += res.data.available_amount
                                    document.getElementById('voucher_code').value = ''
                                }
                                this.voucher = res.data
                                if (this.voucher.is_blocked) {
                                    this.voucherBlocked = true
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = false
                                } else if (this.voucher.available_amount == 0) {
                                    this.voucherBlocked = false
                                    this.invalidVoucher = false
                                    this.voucherApplied = false
                                    this.voucherAmountNull = true
                                } else {
                                    this.invalidVoucher = false
                                    this.voucherApplied = true
                                    this.voucherAmountNull = false
                                    this.voucherBlocked = false
                                }
                            }
                        }
                    })
                    .catch(err => {
                        this.invalidVoucher = true
                        this.voucherApplied = false
                        this.voucher = null
                        this.voucherAmountNull = false
                        this.error = err.response.data['message']
                    })
            } else {
                this.currentVoucher = null
            }
        },
        parseDate(date) {
            moment.locale('fr')
            return moment(date).format('DD/MM/YYYY')
        },

        deleteBC(e) {
            const isLargeNumber = element => element.id == e.id
            const voucherToDelete = this.voucherArray.find(isLargeNumber)
            const index = this.voucherArray.findIndex(isLargeNumber)
            if (index > -1) {
                this.voucherArray.splice(index, 1)
                this.voucherTotal -= e.available_amount
                this.vouchersUsed.splice(
                    this.vouchersUsed.findIndex(v => v.code == voucherToDelete.code),
                    1
                )
            }
        },
    },
}
</script>

<style></style>
